import { useCustomAttributeFiltersV2 } from "#src/components/hooks/FilterPanel/useCustomAttributeFilters";
import useLocalization from "#src/hooks/useLocalization";
import { RoleContext } from "#src/routes/settings/roles-and-permissions/roles/[roleId]/detail/RoleContext";
import {
  FilterBuilderFieldsType,
  FilterDisplay,
  KeyValuePanel,
  Panel,
} from "@validereinc/common-components";
import { AssetType } from "@validereinc/domain";
import classNames from "classnames/bind";
import { isEmpty } from "es-toolkit/compat";
import React, { useContext, useEffect, useState } from "react";
import styles from "./RoleDetailsPanel.module.css";

const cx = classNames.bind(styles);

export const RoleDetailsPanel = () => {
  const { localize } = useLocalization();
  const { roleQuery, roleMembersQuery, rolePermissionsQuery } =
    useContext(RoleContext) ?? {};
  const facilitiesReadFilter = rolePermissionsQuery?.data?.find(
    (permission) => permission.name === "facilities:read"
  )?.filter;
  const [filter, setFilter] = useState(facilitiesReadFilter ?? {});

  const { customAttributeFilterBuilderFieldDefinitions } =
    useCustomAttributeFiltersV2({
      assetType: AssetType.FACILITY,
    });

  useEffect(() => {
    setFilter(facilitiesReadFilter ?? {});
  }, [facilitiesReadFilter]);

  const fields: FilterBuilderFieldsType = {
    name: {
      data_type: "string",
      display_name: `${localize("Facility")} Name`,
    },
    ...customAttributeFilterBuilderFieldDefinitions,
  };

  return (
    <>
      <KeyValuePanel
        panelMaxColumnCount={2}
        panelKeyValueListProps={{ maxRowCount: 3, variant: "shaded" }}
        panelProps={{ isFluidY: false }}
        data={[
          {
            title: "Description",
            value: roleQuery?.data?.description,
          },
          {
            title: "Members",
            value: roleMembersQuery?.data?.length ?? 0,
          },
          {
            title: "Permissions",
            value: rolePermissionsQuery?.data?.length ?? 0,
          },
        ]}
      />
      {!isEmpty(filter) ? (
        <Panel
          title={`${localize("Facility")} Filters`}
          isFluidY={false}
        >
          <FilterDisplay
            className={cx("filter-display")}
            fields={fields}
            filter={filter}
          />
        </Panel>
      ) : null}
    </>
  );
};
